import { createFileRoute, redirect } from '@tanstack/react-router';
import { getAuthStore } from '../main';
import { SpSidebar } from '../components/Sidebar';
import { Pane, HStack } from '@sheridan-prize/ui';
import { MaterialSymbol, StateLayer } from '@moonjellydigital/react-components';
import { CategoryList } from '../components/CategoriesListView';
import { Link } from '../components/Link';

export const Route = createFileRoute('/categories')({
  beforeLoad: async () => {
    await getAuthStore().fetchUser();
    const isAuthenticated = getAuthStore().getIsAuthenticated();

    if (!isAuthenticated) {
      throw redirect({ to: '/login' });
    }

    if (getAuthStore().getUser()?.role !== 'superadmin') {
      throw redirect({ to: '/' });
    }

    await getAuthStore().fetchUserDoc();
  },
  component: Categories,
});

function Categories() {
  return (
    <>
      <SpSidebar />
      <Pane classes={'sp-main'} tag="main">
        <HStack gap="s4" align="center" padBlockEnd="s4">
          <h1 style={{ maxWidth: 'max-content', marginBlockStart: '0' }}>
            Categories
          </h1>
          <Link
            to="/categories/add"
            className={'mjd-button mjd-button_filled'}
            style={{ maxWidth: 'max-content', justifyContent: 'flex-start' }}
          >
            <StateLayer tag="span" />
            <MaterialSymbol icon="add" /> Add Category
          </Link>
        </HStack>
        <CategoryList />
      </Pane>
    </>
  );
}
